// @flow
import { SeaLogActionTypes } from './constants';

type SeaLogAction = { type: string, payload: {} | string };

// common success
export const seaLogApiResponseSuccess = (actionType: string, data: any): SeaLogAction => ({
    type: SeaLogActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const seaLogApiResponseError = (actionType: string, error: string): SeaLogAction => ({
    type: SeaLogActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getSeaLogs = (id: string): SeaLogAction => ({
    type: SeaLogActionTypes.GET_SEA_LOG,
    payload: { id },
});

export const addSeaLogs = (seaLogs:any):SeaLogAction=>({
    type:SeaLogActionTypes.ADD_SEA_LOG,
    payload:seaLogs
})
export const updateSeaLogs = (seaLogs:any):SeaLogAction=>({
    type:SeaLogActionTypes.UPDATE_SEA_LOG,
    payload:seaLogs
})
export const deleteSeaLogs = (id:string):SeaLogAction=>({
    type:SeaLogActionTypes.DELETE_SEA_LOG,
    payload:{id}
})

export const listSeaLogs = (params:any): SeaLogAction => ({
    type: SeaLogActionTypes.LIST_SEA_LOGS,
    payload: params,
});

export const setFiltersSeaLogs = (params:any): SeaLogAction => ({
    type: SeaLogActionTypes.SET_FILTER,
    payload: params,
})

export const resetSeaLogs = (): SeaLogAction => ({
    type: SeaLogActionTypes.RESET,
    payload: {},
});

